import { useForm } from 'react-hook-form';

import { TSupportForm } from '../types';

export function useSupportsDrawerFormState() {
  const initialValues: TSupportForm = {
    name: '',
  };

  const form = useForm<TSupportForm>({
    mode: 'all',
    defaultValues: initialValues,
  });

  return { form, initialValues };
}
